( function () {
   
    'use strict';

    ( function ( $ ) {
        

        if($('.oldurl').length > 0){
            var oldurls = $('.oldurl').val();
            var userid = $.cookie("wps_uid");
            if(userid == ''){
                window.location.href = oldurls;
            }
        }
        $(".predictions-game-tab").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".predictions-game-tab").removeClass('active');
              $(this).addClass('active');
              $(".predictions-game-tab-content").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            
                var catid = $(this).data("id");
                var matid = $(this).data("mid");
                getqdata(catid,matid);
               
            }
            return false;
        });
       
      
        function matchsubmit() {
            $(".predictions-right-match-bottom a.match-submit").click(function () {
                
                var catid = $(this).data("id");
                var anns = $('.answer-'+catid).val();
                var choise = $('.coices-'+catid).val();
                var types = $('.type-'+catid).val();
                
                if(types == undefined){
                    
                    if(anns != undefined && anns != ''){
                        $(this).html("please wait...");
                        if(choise != 'multiple'){
                            $.ajax({
                                type: "POST",
                                cache: false,
                                url: ssAjax.ajaxurl,
                                data: { nonce: ssAjax.nonce, choise:choise, anns:anns, catid:catid, action: 'getsubmitdata' },
                                dataType: 'json',
                                success: function (responses) {
                                    
                                    if(responses != 'Nodata'){
                                        $('.sucess').fadeIn();
                                        
                                            //getqdata(responses);
                                            //$('.activex.active').removeClass('active').next().addClass('active');
                                            var catid = $('.activex.active').data("id");
                                            var matid = $('.activex.active').data("mid");
                        
                                            getqdata(catid,matid);
                                        
                                        
                                        // toastr.options = {
                                        //     "closeButton": true,
                                        //     "debug": false,
                                        //     "newestOnTop": false,
                                        //     "progressBar": true,
                                        //     "positionClass": "toast-top-center",
                                        //     "preventDuplicates": false,
                                        //     "onclick": null,
                                        //     "showDuration": "300",
                                        //     "hideDuration": "1000",
                                        //     "timeOut": "10000",
                                        //     "extendedTimeOut": "1000",
                                        //     "showEasing": "swing",
                                        //     "hideEasing": "linear",
                                        //     "showMethod": "fadeIn",
                                        //     "hideMethod": "fadeOut"
                                        // }
                                        // toastr["success"]("Data Submitted Successfully!!")
                                        //getqdata(responses);
                                    }
                                }
                            });
                        }
                        else{
                            
                            $.ajax({
                                type: "POST",
                                cache: false,
                                url: ssAjax.ajaxurl,
                                data: { nonce: ssAjax.nonce, choise:choise, anns:anns, catid:catid, action: 'getsubmitmultidata' },
                                dataType: 'json',
                                success: function (responses) {
                                    
                                    if(responses != 'Nodata'){
                                        $('.sucess').fadeIn();
                                        // setTimeout(function() {
                                        //     getqdata(responses);
                                        // }, 5000 );
                                        $('.activex.active').removeClass('active').next().addClass('active');
                                        var catid = $('.activex.active').data("id");
                    
                                        getqdata(catid);
                                        // toastr.options = {
                                        //     "closeButton": true,
                                        //     "debug": false,
                                        //     "newestOnTop": false,
                                        //     "progressBar": true,
                                        //     "positionClass": "toast-top-center",
                                        //     "preventDuplicates": false,
                                        //     "onclick": null,
                                        //     "showDuration": "300",
                                        //     "hideDuration": "1000",
                                        //     "timeOut": "10000",
                                        //     "extendedTimeOut": "1000",
                                        //     "showEasing": "swing",
                                        //     "hideEasing": "linear",
                                        //     "showMethod": "fadeIn",
                                        //     "hideMethod": "fadeOut"
                                        // }
                                        // toastr["success"]("Data Submitted Successfully!!")
                                        // getqdata(responses);
                                    }
                                }
                            });
                        }

                    }
                }
                else{
                    if(anns != undefined && anns != ''){
                    var ansone = $('.ansone').val();
                    var anstwo = $('.anstwo').val();
                    var ansthree = $('.ansthree').val();
                    $.ajax({
                        type: "POST",
                        cache: false,
                        url: ssAjax.ajaxurl,
                        data: { nonce: ssAjax.nonce, choise:choise, anns:anns, catid:catid, ansone:ansone, anstwo:anstwo, ansthree:ansthree, action: 'getsubmittype6' },
                        dataType: 'json',
                        success: function (responses) {
                            
                            if(responses != 'Nodata'){
                                $('.sucess').fadeIn();
                                // setTimeout(function() {
                                //     getqdata(responses);
                                // }, 5000 );
                                $('.activex.active').removeClass('active').next().addClass('active');
                                var catid = $('.activex.active').data("id");
            
                                getqdata(catid);
                                // toastr.options = {
                                //     "closeButton": true,
                                //     "debug": false,
                                //     "newestOnTop": false,
                                //     "progressBar": true,
                                //     "positionClass": "toast-top-center",
                                //     "preventDuplicates": false,
                                //     "onclick": null,
                                //     "showDuration": "300",
                                //     "hideDuration": "1000",
                                //     "timeOut": "10000",
                                //     "extendedTimeOut": "1000",
                                //     "showEasing": "swing",
                                //     "hideEasing": "linear",
                                //     "showMethod": "fadeIn",
                                //     "hideMethod": "fadeOut"
                                // }
                                // toastr["success"]("Data Submitted Successfully!!")
                                // getqdata(responses);
                            }
                        }
                    });
                    }
                }
                // $(".predictions-game-tab.active").next().removeClass('lock-icon');
                // $(".predictions-game-tab.active").next().removeClass('noclick');

                return false;
            });
        }
        function getqdata(catid,matid) {
            $('#loading').fadeIn();
            $.ajax({
                type: "POST",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, catid:catid,matid:matid, action: 'getquedata' },
                dataType: 'html',
                success: function (responses) {
                    //console.warn(responses);
                    $('#loading').fadeOut();
                    $('#predictions-game-1-content').html('');
                    $('#predictions-game-1-content').html(responses);
                    $('#predictions-game-1-content').addClass('active');
                    matchvote();
                    matchsubmit();
                    matchmslect();
                }
            });
        }
        function matchvote() {
            
            $(".single ul li").click(function () {
                if ($(this).hasClass('active')) {
                } else {
                    
                    $(".single ul li").removeClass('active');
                    $(this).addClass('active');
                    var idz = $(this).data("id");
                    var andval = $(this).attr("id");
                    $('.answer-'+idz).val(andval);

                }
            });
        }
        function matchmslect() {
            
            $(".multiple ul li").click(function () {
                
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    
                    var totals = $('.multiple ul li.active').length;
                    
                    $('.countnum').html(totals);

                    //alert(totals);
                    var idz = $(this).data("id");
                    var andval = $(this).attr("id");
                        var cur_val = $('.answer-'+idz).val();
                        if(cur_val != ''){
                            var values = cur_val.split(',');
                            for(var i = 0 ; i < values.length ; i++) {
                                if(values[i] == andval) {
                                  values.splice(i, 1);
                                  //console.warn(values.splice(i, 1));
                                  $('.answer-'+idz).val(values.join(','));
                                }
                                else{
                                    
                                }
                              }
                            
                        }
                     
                } else {
                    
                    //$(".predictions-right-match-center .multis ul li").removeClass('active');
                    $(this).addClass('active');
                    var idz = $(this).data("id");
                    
                    var totals= $('.nocho-'+idz).val();
                    var selecd = $('.multiple ul li.active').length;
                    
                    if(selecd <= totals){
                        $('.countnum').html(selecd);
                        var andval = $(this).attr("id");
                        //$('.answer-'+idz).val(andval);
                            var cur_val = $('.answer-'+idz).val();
                            if(cur_val != ''){
                                var values = cur_val.split(',');
                                for(var i = 0 ; i < values.length ; i++) {
                                    if(values[i] == andval) {
                                      values.splice(i, 1);
                                      return values.join(',');
                                    }
                                    else{
                                        $('.answer-'+idz).val(cur_val + "," + andval);
                                    }
                                  }
                            }
                            else{
                                $('.answer-'+idz).val(andval);
                            }
                    }
                    else{
                        $(this).toggleClass('active');
                        toastr.options = {
                            "closeButton": true,
                            "debug": false,
                            "newestOnTop": false,
                            "progressBar": true,
                            "positionClass": "toast-top-center",
                            "preventDuplicates": false,
                            "onclick": null,
                            "showDuration": "300",
                            "hideDuration": "1000",
                            "timeOut": "10000",
                            "extendedTimeOut": "1000",
                            "showEasing": "swing",
                            "hideEasing": "linear",
                            "showMethod": "fadeIn",
                            "hideMethod": "fadeOut"
                          }
                          toastr["error"]('Can not select more then '+totals)
                    }
                    //var andval = $(this).attr("id");
                    //$('.answer-'+idz).val(andval);

                }
            });
        }
        
        
    } )( jQuery );
} )();

